












































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Number from "@/shared/filters/Number.ts";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import loadingService from "@/service/loadingService";
import UserFooter from "@/components/UserFooter.vue";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import CouponPage from "@/page/user/CouponPage.vue";
@Component({
  filters: {
    Number
  },
  components: {
//    appSideTabRight: SideTabRight,
    ConfirmDialog,
    UserFooter,
    TopBarTitle,
    InputNumber
  }
})
export default class QuickCouponComponent extends CouponPage {

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  @Prop() modeQuick: boolean;
  excludingFlg: boolean = false;
  excludingTex: string = "";
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  addClass: any = "top-bar__override";
  loadingService: loadingService = new loadingService();

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  mounted() {
    this.$emit("onActiveSideTab", 1);
    if(this.modeQuick){
      this.excludingFlg = false;
      this.excludingTex = "税込";
    }else{
      if( this.isExcludingTax ) this.excludingFlg = true;
      this.excludingTex = this.taxLabel;
    }
  }
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  onConfirm(isConfirm: number) {
    if (this.couponData) {
      if (this.couponData.coupon && this.couponData.coupon.items) {
        this.couponData.coupon.subTotalZk = this.subTotalZk;
        this.couponData.coupon.subTotalZn = this.subTotalZn;
      }
      this.setCoupon(this.couponData);
      let _isConfirm: any = isConfirm;
      if (isConfirm == 0) {
        _isConfirm = this.couponData.isConfirm;
      }
      if (
        this.couponDataForSave.coupon &&
        this.couponDataForSave.proposal &&
        this.couponDataForSave.tokuten
      ) {
        this.loadingService.show();
        this.reqService
          .saveCoupon({
            coupons: this.couponDataForSave.coupon.items,
            proposals: this.couponDataForSave.proposal.items,
            tokutens: this.couponDataForSave.tokuten.items,
            sknUketsukeUserJouhou: {
              isConfirmCoupon: _isConfirm
            },
            sknUketsukeExtendsId: this.uketsukeExtendsId
          })
          .then(
            (res: any) => {
              this.loadingService.hide();
              if (isConfirm == 1) {
                this.confirm(_isConfirm);
              }
              /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [START] */
              this.$emit("closeNext");
              /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [END] */
            },
            error => {
              this.loadingService.hide();
              this.$notify.error({
                title: "エラー",
                message: MESSAGE.SystemError
              });
              /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [START] */
              this.$emit("closeNext");
              /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [END] */
            }
          );
      } else {
        this.confirm(_isConfirm);
        /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [START] */
        this.$emit("closeNext");
        /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [END] */
      }
    }
  }
}
